<template>
    <div>
        <app-bar :title="t('races_title')"></app-bar>

        <v-layout>
            <race-execution-collection></race-execution-collection>
        </v-layout>
    </div>
</template>

<script lang="ts">
    import { defineComponent, reactive, toRefs } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import RaceExecutionCollection from '@/components/race-executions/RaceExecutionCollection.vue'

    export default defineComponent({
        components: {
            RaceExecutionCollection,
        },

        /**
         * @param props
         */
        setup(props) {
            const state = reactive({})

            return {
                ...useI18n(),
                ...toRefs(state)
            }
        }
    })
</script>